<template>
  <PageMain
    ref="main"
    :tableData="tableData"
    :loading="loading"
    :tablePage="page"
    @reload="reload"
    @check="(e) => $emit('check', e)"
  >
    <PageHeader ref="header" slot="header" @query="getData" @reset="resetPage">
    </PageHeader>

    <pagination
      slot="pager"
      :current-page="page.curPage"
      :page-size="page.pageSize"
      :page-total="page.pageTotal"
      @change="handlePaginationChange"
    />
  </PageMain>
</template>
<script>
import PageHeader from './header'
import PageMain from './main.vue'
import BaseTable from '@/mixins/base-table'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [BaseTable, EditLoading],
  components: { PageMain, PageHeader },
  data() {
    return { usePage: true }
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .customerDevTrackingQuotationFabricOptionsApi({ ...form, ...this.page })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
  },
}
</script>
<style lang="scss" scoped>
.clearable-button {
  .el-icon-circle-close {
    display: none;
  }
}
.clearable-button.clearable:hover {
  .el-icon-circle-close {
    display: inline-block;
    z-index: 999;
  }
  .el-icon-circle-close:hover {
    transform: scale(1.2);
  }
}
</style>
